<template>
    <el-table :table="capacite_financiere_menage_table" />
</template>

<script>
import { mapGetters } from "vuex";

import getParameter from "@/libs/get_parameter.js";

import PageMixin from "@/components/study/editor/pages/page.mixin.js";
import number from "@/libs/number";
import Finance from "tvm-financejs";

export default {
	mixins: [PageMixin],
	computed: {
		...mapGetters([
			"etude_data"
		]),

		capacite_financiere_menage_table () {
			try {
				const component = this.active_study.qlikData.component.find((component) => {
					return component.name == "budget" || component.id == "5.1";
				});
  
				const data = component.content[this.getBudgetParameter("zoneGeo", this.budgetParameters.geo.default)];

				const finance = new Finance();

				const table = {
					head: [data.header_list.map(header => header.value)],
					body: data.data_list.map(item => {
						let budgetMax;

						try {
							budgetMax = Math.round(-finance.PV(((number.clean(this.active_study.etudeData.gie.sectionDynamiqueMarcheResidentiel.tauxInteret) + 0.36) / 100) / 12, (number.clean(this.active_study.etudeData.gie.sectionDynamiqueMarcheResidentiel.dureeEmprunt) || 0) * 12, item.values[0].value * 0.33, 0, 1) / (1 - 0.1) / 100) * 100 + "€";
						} catch(e) {
							console.warn("Impossible de calculer le budget max des capacités financière de ménage.", e);
							budgetMax = "Calcul impossible";
						}
						return [item.label, ...item.values.map(value => `${value.value}${value.unit}`), budgetMax];
					}),
					config: {
						cols_width: [13, 29, 29, 29],
					},
				};
  
				return table;
			} catch (e) {
				console.error(e);
				this.$emit("ErrorTableBudget");
				return [];
			}
		},
		budgetParameters () {
			try {
				const parameters =
			this.active_study.qlikData.parameters.editmode.find((editmode) => {
				return editmode.theme == "budget";
			});

				return parameters;
			} catch (e) {
				return false;
			}
		},
	},
	methods: {
		getBudgetParameter (name, defaultValue) {
			return getParameter(this.etude_data, "budget", name, defaultValue);
		},
	},
};
</script>
